import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leave-type',
  templateUrl: './leave-type.component.html',
  styleUrls: ['./leave-type.component.scss']
})
export class LeaveTypeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
